import React from "react";
import styles from "./DashboardNavbar.module.css";
import logo from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import {GoSearch} from 'react-icons/go';
import {BiBell} from 'react-icons/bi'

export default function DashboardNavbar() {
  return (
    <div>
      <div className={styles.navbar}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logo} />
        </Link>
        <div className={styles.searchCont}>
            <GoSearch color="#D1E1EA" size={25} style={{cursor:"pointer"}} />
          <input className={styles.search} placeholder="Search here..." />
        </div>
        <div className={styles.navoptCorner}>
          <Link to="/dashboard/plan-a-trip">
          <button className={styles.newApplication}>New Application</button>
          </Link>
          <BiBell color="#ffffff" size={30} style={{cursor:"pointer"}} />
        </div>
      </div>
    </div>
  );
}
